import React from "react";
import Select from "react-select";
import {Button,CardBody,Row,Col,InputGroup,Input,ListGroup,ListGroupItem } from "reactstrap";
import { ToastContainer } from "react-toastify";
import ImageUploadContainer from "../User/adding-user/ImageUploadContainer";
import type { PickedImage } from "../User/adding-user/ImageUploadContainer";
import type { SelectOption } from "@/utils/selectOptions";
import type { AdDraft, AdOption } from "./adForm";

export type AddAdsViewProps = {
  loading: boolean;
  ad: AdDraft;
  positions: SelectOption[];
  clients: AdOption[];
  products: AdOption[];
  client: AdOption | null;
  product: AdOption | null;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onSelectPosition: (opt: SelectOption | null) => void;
  onSelectClient: (opt: AdOption | null) => void;
  onSelectProduct: (opt: AdOption | null) => void;
  onClickAdd: () => void;
  onImageUpload: (img: PickedImage) => void;
};

const AddAdsView = ({
  loading,
  ad,
  positions,
  clients,
  products,
  client,
  product,
  onChange,
  onSelectPosition,
  onSelectClient,
  onSelectProduct,
  onClickAdd,
  onImageUpload,
}: AddAdsViewProps) => {
    
  return (
    <>
      <div className="rna-wrapper"><ToastContainer /></div>

      <CardBody className="px-lg-2">
        <ListGroup className="list my--3" flush>
          <ListGroupItem className="px-0">
            <Row className="text-center">
              <Col>
                <ImageUploadContainer ImageUpload={onImageUpload} />
              </Col>
            </Row>
          </ListGroupItem>

          {/* Title */}
          <ListGroupItem className="px-0">
            <Row className="align-items-center">
              <div className="col ml-2 ">
                <h4 className="mb-2">
                  <a onClick={(e) => e.preventDefault()}>Title</a>
                </h4>
                <InputGroup className="mb-2">
                  <Input
                    placeholder="Title"
                    type="text"
                    name="adsTitle"
                    value={ad.adsTitle}
                    onChange={onChange}
                  />
                </InputGroup>
              </div>
            </Row>

            {/* Description */}
            <Row className="align-items-center">
              <div className="col ml-2 ">
                <h4 className="mb-2">
                  <a onClick={(e) => e.preventDefault()}>Description</a>
                </h4>
                <InputGroup className="mb-2">
                  <Input
                    placeholder="Description"
                    type="text"
                    name="adsDescription"
                    value={ad.adsDescription}
                    onChange={onChange}
                  />
                </InputGroup>
              </div>
            </Row>

            {/* Link */}
            <Row className="align-items-center">
              <div className="col ml-2 ">
                <h4 className="mb-2">
                  <a onClick={(e) => e.preventDefault()}>Link</a>
                </h4>
                <InputGroup className="mb-2">
                  <Input
                    placeholder="Link"
                    type="text"
                    name="adsLink"
                    value={ad.adsLink}
                    onChange={onChange}
                  />
                </InputGroup>
              </div>
            </Row>

            {/* Position */}
            <Row className="align-items-center">
              <div className="col ml-2 ">
                <h4 className="mb-2">
                  <a onClick={(e) => e.preventDefault()}>Position</a>
                </h4>
                <Select
                  value={positions.find((p) => p.value === ad.adsPosition) || null}
                  options={positions}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={onSelectPosition}
                  isClearable
                  isSearchable
                />
              </div>
            </Row>

            {/* Related to */}
            <Row className="align-items-center">
              <div className="col ml-2 mt-2 ">
                <h4 className="mb-2">
                  <a onClick={(e) => e.preventDefault()}>Related to : (optional)</a>
                </h4>
              </div>
            </Row>

            {/* Client */}
            <Row className="align-items-center">
              <div className="col ml-2 mr-2 ">
                <h4 className="mb-2">
                  <a onClick={(e) => e.preventDefault()}>Client</a>
                </h4>
                <Select
                  value={client}
                  options={clients}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={onSelectClient}
                  isClearable
                  isSearchable
                />
              </div>
            </Row>

            {/* Product */}
            <Row className="align-items-center">
              <div className="col ml-2 mr-2 ">
                <h4 className="mb-2">
                  <a onClick={(e) => e.preventDefault()}>Product</a>
                </h4>
                <Select
                  value={product}
                  options={products}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={onSelectProduct}
                  isClearable
                  isSearchable
                />
              </div>
            </Row>

            {/* Submit */}
            <Row className="align-items-center">
            
                <Col className="text-right">
                                      <Button
                                        className="my-4"
                                        color="primary"
                                        type="button"
                                       onClick={onClickAdd}
                                   disabled={loading}

                                      >
                                        Add
                                      </Button>
                                    </Col>
            </Row>
          </ListGroupItem>
        </ListGroup>
      </CardBody>
    </>
  );
};

export default AddAdsView;
